
let inputsPack = document.querySelectorAll('input[name="product_pack"]'),
  formPack = document.querySelector('form[data-type="add-to-cart-form"]'),
  productPackSelector = document.querySelector('.product_packs');
  cardInputs = document.querySelectorAll('.cart__set-information-set input');

if (document.querySelector('.product_pack_variants')) {
  const variants = document.querySelectorAll('.product_pack_variants input');

  if (variants.length > 0) {
    const currentVariant = Array.from(variants).find(variant => variant.checked);

    if (currentVariant) {
      const variantId = currentVariant.dataset.variantId;
      formPack.querySelector('input[name="id"]').value = variantId;
    }else{
      const submitButton = formPack.querySelector('.product-form__submit');
      productPackSelector.classList.add('all-sold-out');

      if (submitButton.disabled === false ) {
          submitButton.disabled = true;
      }
      
    }
  }

  variants.forEach(variant => {
    variant.addEventListener("change", function (event) {
      let variantSelectedId = event.target.dataset.variantId;
      formPack.querySelector('input[name="id"]').value = variantSelectedId;
    });
  });

}


inputsPack.forEach(function (input) {
  input.addEventListener("change", function (event) {
    let selectedValue = event.target.value,
      selectProperty = event.target.dataset.property,
      selectQuantity = event.target.value,
      pricePack = document.querySelectorAll('.price-item--regular.final-price'),
      form = this.closest('.button_quantity__product').querySelector('form'),
      ProductSetOf = document.querySelectorAll('.product_title-setof');

    if (event.target.value === 'single') {
      selectedValue = '1';
      selectQuantity = 1;
    } else {
      selectedValue = event.target.value;
      selectQuantity = parseInt(selectQuantity); 
    }

    console.log(form)

    form.querySelector('input[name="properties[Set]"]').value = selectProperty;
    form.querySelector('input[name="properties[_quantity]"]').value = selectQuantity;
    form.querySelector('input[name="quantity"]').value = selectedValue;

    pricePack.forEach((element) => {
      let currencySymbol = element.innerText.match(/[^\d.,]+/);
      let priceValue = parseFloat(element.dataset.price.replace(/[^\d.-]+/g, "")) / 100;

      if (!isNaN(selectQuantity)) {
        priceValue *= selectQuantity;
        element.innerText = `${currencySymbol}${priceValue.toFixed(2)}`;
      } else {
        console.error('selectQuantity no es un número válido');
      }
    });

    ProductSetOf.forEach((element) => {
      if (selectedValue == 1) {
        element.innerText = 'Single'
      }else{
        element.innerHTML = 'Set of ' + selectedValue;
      }
    })
  });
});


cardInputs.forEach(function (pack) {

  packs.addEventListener("change", function (event) {


      console.log(pack)
  });
});  